import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LogoIcon from "../../assets/svg/logoIcon";
import { useAuth } from "../../context/authContext";
import createAxiosInstance from "../../utils/axiosConfig";
import { change_password } from "../../utils/endpoints";
import { validate } from "../../utils/formValidate";
import Alert from "../common/alerts/alert";

const ChangePasswordPublic = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { isAuthenticated } = useAuth();
	const [formData, setFormData] = useState({
		password: "",
		confirmPassword: "",
	});
	
	const [errors, setErrors] = useState<any>({});
	const [responseError, setResponseError] = useState<any>("");
	const [alertVisible, setAlertVisible] = useState(false);
	const [loading, setLoading] = useState(false);

	const queryParams = new URLSearchParams(location.search);
	const token = queryParams.get("token");
	if (token) {
		// If a token exists in query parameters, save it to localStorage
		localStorage.setItem("changePasswordToken", token);
	} else {
		// user isn't authenticated already.
		if (!isAuthenticated) {
			// If no token in localStorage, redirect to login
			navigate("/login");
		}
	}

	// safely handle user authentication ...
	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const token = queryParams.get("token");
		if (token) {
			// If a token exists in query parameters, save it to localStorage
			localStorage.setItem("changePasswordToken", token);
		} else {
			// user isn't authenticated already.
			if (!isAuthenticated) {
				// If no token in localStorage, redirect to login
				navigate("/login");
			}
		}

		console.log(isAuthenticated, " 	isAuthenticated");
	}, []);

	const handleChange = (
		e: React.ChangeEvent<
			HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
		>
	) => {
		const { name, value } = e.target;
		const newFormData = { ...formData, [name]: value };
		setFormData(newFormData);
		
		const tempErrors: any = { ...errors }; // Keep existing errors
		const passwordPattern =
			/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&^<>~/`+\-_.#,{}\[\];':"|\\=)(])[A-Za-z\d@$!%*?&^<>~/`+\-_.#,{}\[\];':"|\\=)(]{8,}$/;

		// Validate password field
		const passwordValue = name === "password" ? value : newFormData.password;
		if (name === "password" || (name === "confirmPassword" && newFormData.password)) {
			if (!passwordValue) {
				tempErrors.password = "Password field is required";
			} else {
				delete tempErrors.password;
				
				// Password pattern validation
				if (!passwordPattern.test(passwordValue)) {
					tempErrors.password =
						"Password must be 8 or more characters with a mix of letters, numbers & symbols.";
				}
			}
		}

		// Validate confirm password field
		const confirmPasswordValue = name === "confirmPassword" ? value : newFormData.confirmPassword;
		if (name === "confirmPassword" || (name === "password" && newFormData.confirmPassword)) {
			if (!confirmPasswordValue) {
				tempErrors.confirmPassword = "Confirm Password field is required";
			} else {
				delete tempErrors.confirmPassword;
				
				// Password matching validation
				if (passwordValue && confirmPasswordValue !== passwordValue) {
					tempErrors.confirmPassword = "Passwords do not match.";
				}
			}
		}

		setErrors(tempErrors);
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!validate(formData, setErrors)) return;
		setLoading(true);
		const email = queryParams.get("email");
		const payload = {
			new_password: formData.password,
			email: email,
		};

		if (!email) {
			setLoading(false);
			return;
		} else {
			payload.email = email;
		}

		try {
			const axiosInstance = createAxiosInstance({
				Authorization: `Bearer ${token}`,
			});
			const response = await axiosInstance.post(change_password, payload);

			if (response.data?.user?.error) {
				setResponseError(response?.data?.user?.error);
				setAlertVisible(true);
			} else {
				setAlertVisible(true);
				setFormData({
					password: "",
					confirmPassword: "",
				});
				setTimeout(() => {
					navigate("/");
				}, 1000);
			}
		} catch (err: any) {
			setResponseError(err?.message);
			setAlertVisible(true);
			console.log(err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<section className="authentication min-vh-100">
			<header className="p-4">
				<div className="container-fluid">
					<div className="card d-flex align-items-center logo-container">
						<LogoIcon />
					</div>
				</div>
			</header>
			
			<div className="container-fluid">
				<div className="row align-items-center min-vh-75 w-100">
					<div className="col-md-12 col-lg-12 col-xl-12">
						<div className="login-container">
							<div className="mb-3">
								{/* <LogoIcon /> */}
							</div>
							<h2 className="my-3 my-md-4" style={{color: "white", fontSize: "26px", fontWeight: '700', lineHeight: '40px', fontFamily: 'Roboto'}}>Setup New Password</h2>
							<p className="text-white mb-4">
								Have you already reset the password? <a href="/" className="text-white fw-bold" style={{textDecoration: 'underline'}}>Sign in</a>
							</p>
							
							<form onSubmit={handleSubmit}>
								<div className="mb-4">
									<label htmlFor="password" className="form-label text-white mb-2">Password</label>
									<input
										type="password"
										className={`form-control form-control-lg bg-white rounded-4 ${errors.password ? "is-invalid" : ""}`}
										id="password"
										name="password"
										value={formData.password}
										onChange={handleChange}
									/>
									<div className="form-text text-white mt-2" style={{fontSize: '0.875rem'}}>
										<i className="bi bi-info-circle"></i> Use 8 or more characters with a mix of letters, numbers & symbols.
									</div>
									{errors.password && <div className="invalid-feedback">{errors.password}</div>}
								</div>
								
								<div className="mb-4">
									<label htmlFor="confirmPassword" className="form-label text-white mb-2">Confirm Password</label>
									<input
										type="password"
										className={`form-control form-control-lg bg-white rounded-4 ${errors.confirmPassword ? "is-invalid" : ""}`}
										id="confirmPassword"
										name="confirmPassword"
										value={formData.confirmPassword}
										onChange={handleChange}
									/>
									{errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
								</div>
								
								<div className="form-check text-start mb-4">
									<input
										className="form-check-input"
										type="checkbox"
										value="1"
										name="agreed"
										id="flexCheckDefault"
										required
									/>
									<label
										className="form-check-label text-white"
										htmlFor="flexCheckDefault"
									>
										I Agree & <a href="/terms-and-conditions" className="text-white fw-bold" style={{textDecoration: 'underline'}}>Terms and conditions</a>
									</label>
								</div>
								
								<div className="mb-4" style={{marginTop: '10%'}}>
								</div>
								
								<div className="d-flex flex-row flex-grow-1 gap-3 align-items-center">
									<div className="d-grid login-btn-container gap-2">
										<button 
											type="submit" 
											className="w-100 btn btn-rounded btn-secondary text-white fw-bold py-3"
											disabled={Object.keys(errors).length > 0 || loading}
											style={{
												background: '#26397E',
												borderRadius: "77.125rem",
												transition: 'all 0.3s ease',
											}}
											onMouseEnter={(e) => {
												const target = e.target as HTMLButtonElement;
												target.style.backgroundColor = '#5376F0 !important';
												target.style.transform = 'translateY(-2px)';
											}}
											onMouseLeave={(e) => {
												const target = e.target as HTMLButtonElement;
												target.style.backgroundColor = '#26397E';
												target.style.transform = 'translateY(0)';
											}}
										>
											{loading ? <div
												className="d-flex justify-content-center align-items-center"
												style={{ height: "20px", color: 'white' }}
											>
												<div className="spinner-border text-white" role="status">
													<span className="visually-hidden">Loading...</span>
												</div>
											</div> : "SUBMIT"}
										</button>
									</div>
								</div>
							</form>
						</div>	
					</div>
				</div>
				<div className="row">
					<div className="d-flex justify-content-end" style={{
						marginRight: '10%',
						paddingRight: '3%',
						marginTop: '1%'
					}}>
						<div className="text-white my-2 px-3">
							Powered By: 
						</div>
						<div className="card d-flex align-items-center logo-container">
							<LogoIcon />
						</div>
					</div>
				</div>
			</div>
			<div className="text-black d-flex flex-row flex-wrap gap-2 footer-container">
				Some information about the platform:
				<ul style={{
					listStyleType: 'none',
					paddingLeft: '0',
					marginLeft: '0',
					display: 'flex',
					flexDirection: 'row',
					gap: '10'
				}}>
					<li style={{borderRight: '1px solid black', paddingRight: '10px', textDecoration: 'underline', cursor: 'pointer'}} onClick={() => navigate("/terms-and-conditions")}> Terms & conditions </li>
					<li style={{borderRight: '1px solid black', paddingRight: '10px', textDecoration: 'underline', paddingLeft: '10px', cursor: 'pointer'}} onClick={() => navigate("/privacy-policy")}>Privacy Policy</li>
					<li style={{cursor: 'pointer', paddingLeft: '10px', textDecoration: 'underline'}} onClick={() => navigate("/disclaimer")}>Disclaimer</li>
				</ul>
			</div>
			<Alert
				message={`${
					responseError.length > 1
						? responseError
						: "Password reset successfull."
				}`}
				type={`${responseError.length > 1 ? "danger" : "success"}`}
				show={alertVisible}
				onClose={() => setAlertVisible(false)}
			/>
		</section>
	);
};

export default ChangePasswordPublic;
